export default __webpack_public_path__ + "static/media/sports3.52ebe15e.png";